export default __webpack_public_path__ + "static/media/e15.8edbcb88.jpg";